module.exports = __webpack_public_path__ + "static/media/health-newsletter.dac88525.png";